// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "P\u0159idej diskuzi";
export const ADD_MENU_ADD_BLOG_POST = "P\u0159idej na ze\u010f";
export const ADD_RECIPE = "P\u0159idej recept";
export const BZ2_ADD_PRODUCT = "P\u0159idej inzer\u00e1t";
export const HOMEPAGE_ADD_BUTTON = "P\u0159idej...";
